export default __webpack_public_path__ + "static/media/Calibrate.66337830.svg";